import { Controller, useFormContext } from 'react-hook-form';
import { RadioCardGroup, type RadioCardOption } from '../components/RadioCardGroup';
import type { SignupFormValues } from '../schema';

type Fase = SignupFormValues['diagnosticoFase'];

const OPTIONS: ReadonlyArray<RadioCardOption<Fase>> = [
  { value: 'IDEACAO', label: 'Ideação', description: 'Validando hipóteses iniciais' },
  { value: 'VALIDACAO', label: 'Validação', description: 'Buscando product-market fit' },
  { value: 'CRESCIMENTO', label: 'Crescimento', description: 'Acelerando vendas e operação' },
  { value: 'EXPANSAO', label: 'Expansão', description: 'Novos mercados e escala' },
  { value: 'MATURIDADE', label: 'Maturidade', description: 'Operação consolidada' },
];

export const Step15DiagnosticoFase = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<SignupFormValues>();

  return (
    <Controller
      control={control}
      name="diagnosticoFase"
      render={({ field }) => (
        <RadioCardGroup<Fase>
          label="Fase atual do negócio"
          value={field.value}
          onChange={field.onChange}
          options={OPTIONS}
          columns={1}
          errorMessage={errors.diagnosticoFase?.message}
        />
      )}
    />
  );
};
